import { useTranslation } from "react-i18next";

import Showcase from "../components/Showcase";
import Fetures from '../components/Fetures';
import CategoryGrid from '../components/Categories';
import CourseCard from "../components/CourseCard";
import { Suspense, useEffect, useState } from "react";
import CardSkeleton from "../components/skeleton/CardSkeleton";
// import NewsLetter from "../components/NewsLetter";
import HowStart from "../components/HowStart ";
import Lunch from "../components/Lunch";
import axios from "axios";
import { PROXY } from "../lib/utils";

const Home = () => {
  const { t } = useTranslation();

  const [categories, setCategories] = useState([]);
  const [totalCourses, setTotalCourses] = useState(0);
  const [categoryCount, setCategoryCount] = useState(0);
  const [usersCount, setUsersCount] = useState(0);
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${PROXY}/categories/subcat`);
        const data = response.data || [];
        setCategories(data);

        const res = await axios.get(`${PROXY}/landingPage/usersCount`);
        const count = res.data?.count || 0;
        setUsersCount(count);

        // Calculate total course count
        const total = data.reduce((sum, cat) => sum + (cat.courseCount || 0), 0);
        setTotalCourses(total);

        // Count categories
        setCategoryCount(data.length);
      } catch (err) {
        console.error("Error fetching categories:", err);
      }
    };

    fetchCategories();
  }, []);
  

  return (
    <>
      <Showcase />
      <Fetures totalCourses={totalCourses} />
      <CategoryGrid categories={categories} />

      <Suspense fallback={<CardSkeleton />}>
        <CourseCard
          url="courses?sort=createdAt%5Bdesc%5D&limit=6"
          title="browse-latest-courses"
          subTitle="sub-browse-latest-courses"
          taq=""
        />
      </Suspense>

      {/* previously featured sections removed per request */}

      <HowStart />

      <Lunch  totalCourses={totalCourses} categoryCount={categoryCount} usersCount={usersCount} />
      
      {/* <NewsLetter /> */}
    </>
  )
}

export default Home
